import { render, staticRenderFns } from "./electric-data-panel.vue?vue&type=template&id=777e4653&scoped=true&"
import script from "./electric-data-panel.vue?vue&type=script&lang=js&"
export * from "./electric-data-panel.vue?vue&type=script&lang=js&"
import style0 from "./electric-data-panel.vue?vue&type=style&index=0&id=777e4653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777e4653",
  null
  
)

export default component.exports